<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="80px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img
              v-if="form.avatar"
              :src="form.avatar"
              :class="['avatar', form.avatarSize === 1 ? 'large' : '']"
            />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>
            建议尺寸：{{
              form.avatarSize === 1 ? '343px * 164px' : '167px * 167px'
            }}
          </span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <!-- 分账方 -->
        <el-form-item label="分账方" v-if="type === 'edit'">
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addSplitAccount(null)"
          >
            增加
          </el-button>
          <el-table stripe :data="form.commissionList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="名称"
              prop="title"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="分帐方ID"
              prop="receiverId"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="比例"
              prop="percent"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="80px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delSplitAccount($index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="城市" prop="city">
          <el-input v-model.trim="form.city" />
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model.trim="form.desc" />
        </el-form-item>
        <el-form-item label="备注" type="textarea" prop="text">
          <el-input v-model.trim="form.text" />
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input-number v-model="form.order" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="splitAccountFormVisible"
      :close-on-click-modal="false"
      title="添加分账方"
      width="800px"
      @close="SplitClose"
    >
      <el-form
        ref="splitForm"
        label-width="120px"
        :model="splitForm"
        :rules="splitFormRules"
      >
        <el-form-item label="名称" prop="title">
          <el-input
            class="fix-width"
            v-model="splitForm.title"
            placeholder="请输入名称"
          />
        </el-form-item>
        <el-form-item label="分账方" prop="receiverId">
          <el-select
            class="fix-width"
            v-model="splitForm.receiverId"
            filterable
            remote
            :remote-method="searchSplitAccount"
            @focus="searchSplitAccount"
            no-data-text="暂无数据"
            placeholder="查询分账方"
          >
            <el-option
              v-for="item in accountList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比例" prop="percent">
          <el-input-number
            :min="0"
            :max="1"
            :step="0.1"
            class="fix-width"
            v-model="splitForm.percent"
            placeholder="请输入比例"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="SplitClose">取 消</el-button>
        <el-button type="primary" @click="splitSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { addBranch, editBranch } from '@/api/branch'
import { findReceiverList } from '@/api/splitAccount'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'BranchBranchEdit',
  emits: ['fetch-data'],
  data() {
    return {
      QNUploadURL,
      QNHost,
      uploadToken: null,
      accountList: [],
      type: 'add',
      form: {
        branchId: '',
        title: '',
        avatar: '',
        imageList: [],
        commissionList: [],
        city: '',
        desc: '',
        text: '',
        order: '',
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请填写标题' }],
        text: [],
      },
      title: '',
      dialogFormVisible: false,
      // fenzhang
      splitForm: {
        title: '',
        receiverId: '',
        percent: '',
      },
      splitFormRules: {
        title: [{ required: true, trigger: 'blur', message: '请输入名称' }],
        receiverId: [
          { required: true, trigger: 'blur', message: '请选择分账方' },
        ],
        percent: [{ required: true, trigger: 'blur', message: '请填写比例' }],
      },
      splitAccountFormVisible: false,
    }
  },
  methods: {
    // 图片
    imageList_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_remove(file, fileList) {
      // this.form.avatar = fileList.map((e) => ({
      //   name: e.name,
      //   url: e.url,
      // }))
      this.form.avatar = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = `${QNHost}/${res.hash}`
    },
    imageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    async showEdit(row) {
      if (!row) {
        this.title = '新增门店'
        this.type = 'add'
      } else {
        this.title = '修改门店'
        this.type = 'edit'
        this.form = Object.assign(
          {},
          {
            branchId: row.branchId,
            title: row.title,
            avatar: row.basic.avatar,
            imageList: row.basic.imageList || [],
            commissionList: row.basic.commissionList || [],
            city: row.basic.city,
            desc: row.basic.desc,
            text: row.basic.text,
            order: row.basic.order,
          }
        )
      }
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.branchId
            ? await editBranch(this.form)
            : await addBranch(this.form)
          this.$baseMessage(
            this.form.branchId ? '修改门店成功' : '新增门店成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          this.$emit('fetch-data')
          this.close()
        } else {
          return false
        }
      })
    },
    addSplitAccount() {
      this.splitAccountFormVisible = true
    },
    splitSave() {
      this.$refs['splitForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.splitForm)
          this.form.commissionList.push(form)
          this.SplitClose()
        } else {
          return false
        }
      })
    },
    delSplitAccount(index) {
      this.form.commissionList.splice(index, 1)
    },
    SplitClose() {
      this.$refs['splitForm'].resetFields()
      this.splitForm = this.$options.data().splitForm
      this.splitAccountFormVisible = false
    },
    async searchSplitAccount(queryString) {
      try {
        const keyword = typeof queryString == 'object' ? '' : queryString
        const ret = await findReceiverList({
          page: 1,
          size: 10000,
          keyword,
          branchId: this.form.branchId,
        })
        console.log(ret)
        this.accountList = ret.list.map((e) => ({
          label: e.title,
          value: e.receiverId,
        }))
      } catch (error) {
        this.accountList = []
      }
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 500px;
}
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar {
  width: 148px;
  height: 148px;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
</style>
